<script setup>
import {computed} from 'vue'
import {useRoute} from 'vue-router'
import {useUserStore} from '@/stores/user'
import {useModalsStore} from '@/stores/modals'
import {useViewStore} from '@/stores/view'

// Define Props
const props = defineProps({
    viewId: String,
})

// Dynamic View Store
const viewStore = useViewStore(props.viewId)

// Route Instance
const route = useRoute()

// Pinia Stores
const userStore = useUserStore()
const modalsStore = useModalsStore()

// Computed Properties
const tableName = computed(() => viewStore.tableName)

const productId = computed(() => {
    return parseInt(route.query.productId)
})

const hasExportAccess = computed(() => {
    return tableName.value ? userStore.access(tableName.value, 'export') : false
})

// Methods
const importCsv = () => {
    modalsStore.show({
        componentName: 'ImportModal',
        obj: {
            tableName: tableName.value,
            productId: productId.value,
        }
    })
}
</script>

<template>
    <button v-if="hasExportAccess" class="d-flex align-items-center" type="button" @click="importCsv">
        <i class="me-2 bi-download"/>
        Import CSV
    </button>
</template>